import {
  Component,
  ElementRef,
  EventEmitter,
  Input,
  OnInit,
  Output,
  ViewChild,
} from "@angular/core";
import { FormArray, FormControl, UntypedFormBuilder, UntypedFormGroup, Validators } from "@angular/forms";
import { MatOptionSelectionChange } from "@angular/material/core";
import { ProviderItem } from "@core/models/providers";
import { CompanyService, UserService } from "@core/services";
import { NgxToastrService } from "@core/services/ngx.toastr.service";
import { ProvidersService, ProviderType } from "@core/services/providers.service";
import { TravelUtilsService } from "@core/services/travel-utils.service";
import { UtilsService } from "@core/services/utils.service";
import { Company, User } from "@models";
import {
  NgbActiveModal,
  NgbDateParserFormatter,
  NgbModal,
} from "@ng-bootstrap/ng-bootstrap";
import { Store } from "@ngrx/store";
import { TranslateService } from "@ngx-translate/core";
import { UserCardModalComponent } from "@shared/component/user-card-modal/user-card-modal.component";
import { AppState } from "app/app.reducer";
import cities from "assets/utils/cities.json";
import hotels from "assets/utils/hotels.json";
import * as moment from "moment";
import { Subscription, take } from "rxjs";

@Component({
  selector: "app-create-custom-hotel",
  templateUrl: "./create-custom-hotel.component.html",
  styleUrls: ["./create-custom-hotel.component.scss"],
})
export class CreateCustomHotelComponent implements OnInit {
  @Input() isAdmin;
  @Input() loading;
  @Input() companyUuid: string;
  @Input() userId: string;
  @Output() sendInfo = new EventEmitter<any>();
  @Input() data;
  editing = false;
  isModal = true;
  hotelsList = [];
  citiesList = [];
  city = "";
  form: UntypedFormGroup;
  prefOptions = [];
  users: User[] = [];
  user: User;
  file: File;
  date = new Date();
  minDateNgStruct = {
    year: this.date.getFullYear() - 1,
    month: this.date.getMonth() + 1,
    day: this.date.getDate(),
  };
  maxDateNgStruct = {
    year: this.date.getFullYear() + 20,
    month: this.date.getMonth() + 1,
    day: this.date.getDate(),
  };
  bodyTravel: any = {};
  subscriptions: Subscription[] = [];
  request: any;
  isInvalid: boolean = false
  userType;
  companyUsers: { name: string; lastname: string; uuid: string }[] = [];
  company: Company;
  @ViewChild("departure") departure: ElementRef;

  @Input() blobUrl;
  @Input() fileBack;
  files: File[] = [];
  filesToRemove: any[] = [];
  existingFiles: any[] = [];
  travelersPerRoom: FormArray;
  filteredUsers: { name: string; lastname: string; uuid: string }[] = [];
  @Input() defaultUser: any;
  bookType: any;
  selectedTravelers = [];
  hotelProviderOptions: ProviderItem[] = [];
  loadingHotelProviders = false;
  private travelerSyncInitialized = false;
  maxSelection = Infinity;

  constructor(
    public activeModal: NgbActiveModal,
    private formBuilder: UntypedFormBuilder,
    public translate: TranslateService,
    private ngbDateParser: NgbDateParserFormatter,
    private travelUtilsService: TravelUtilsService,
    private utilsService: UtilsService,
    private modalService: NgbModal,
    private ngxToastrService: NgxToastrService,
    private userService: UserService,
    private store: Store<AppState>,
    private companyService: CompanyService,
    private providersService: ProvidersService
  ) { }

  ngOnInit(): void {
    if (this.fileBack) {
      this.existingFiles = Array.isArray(this.fileBack) ? this.fileBack : [this.fileBack];
    }
    if (Array.isArray(this.files[0])) {
      this.files = this.files.reduce((acc, val) => acc.concat(val), []);
    }

    this.bookType = this.data?.type;
    this.data && this.data !== null
      ? (this.editing = true)
      : (this.editing = false);
    if (this.userId) {
      this.userService
        .getUser(this.userId)
        .pipe(take(1))
        .subscribe((user: User) => {
          this.user = user;
          if (!this.data?.hotel && this.userType === "EMPLOYEE" && this.bookType !== 'airbnb') {
            this.defaultUser = {
              name: this.user.name,
              lastname: this.user.lastname,
              uuid: this.user.uuid
            };
  
            this.form.get("defaultTraveler").setValue([{ 
              uuid: this.defaultUser.uuid, 
              name: this.defaultUser.name, 
              lastname: this.defaultUser.lastname 
            }]);
            this.updateTravelersPerRoom(this.form.get('rooms').value);
          }

          if (this.request && this.bookType !== 'airbnb') {
            const roomsValue = Number(this.request?.rooms) || 1;
            this.form.patchValue({ rooms: roomsValue });
            const firstRoomTravelers = this.request.travelersPerRoom[0]?.travelers.map(t => ({
                uuid: t.uuid,
                name: t.name,
                lastname: t.lastname
            })) || [];
        
            this.form.get("defaultTraveler")?.setValue(firstRoomTravelers);
        
            const travelersPerRoomFormatted = this.request.travelersPerRoom.slice(1).map(room => 
              room.travelers.map(t => ({
                  uuid: t.uuid,
                  name: t.name,
                  lastname: t.lastname
              }))
            );
            this.form.get("travelersPerRoom")?.setValue(travelersPerRoomFormatted);
            this.updateTravelersPerRoom(this.request.rooms);
          }
          
          if (this.user?.companyUuid) {
            this.companyService.getCompany(this.user.companyUuid).subscribe(
              (company: Company) => {
                this.company = company;
              },
              (error) => {}
            );
          }
        });
    }
    this.store
      .select("auth")
      .pipe(take(1))
      .subscribe((res) => {
        if (res.isAuthenticated) {
          this.userType = res.user.type;
        }
      });
    this.form = this.formBuilder.group({
      file: [
        this.editing ? this.data.file : '',
        this.fileBack && this.blobUrl ? [] : [],
      ],
      hotel: [
        { value: this.editing
          ? this.data.hotel
            ? this.data.hotel.name
            : this.data.hotelName
          : this.request
            ? this.request.hotelName
            : '', disabled: (this.editing && this.data.codePetition) ||this.userType != "EMPLOYEE" },
        [Validators.required],
      ],
      locator: [
        this.editing
          ? (this.data.locator ? this.data.locator : (this.data.apiReference ? this.data.apiReference : this.data.bookedApiReference ))
          : this.request
            ? this.request.locator
            : "",
      ],
      customCode: [
        this.editing && this.data?.customCode && this.data.customCode !== "null"
          ? this.data.customCode
          : this.request?.customCode && this.request.customCode !== "null"
            ? this.request.customCode
            : "",
      ],
      costCenter: [
        this.editing && this.data?.costCenter && this.data.costCenter !== "null"
          ? this.data.costCenter
          : this.request?.costCenter && this.request.costCenter !== "null"
            ? this.request.costCenter
            : "",
      ],
      city: [
        { value: this.editing
          ? this.data.hotel
            ? this.data.hotel.destinationName
            : this.data.destinationName
          : this.request
            ? this.request.city
            : '', disabled: (this.editing && this.data.codePetition) || this.userType != "EMPLOYEE" },
        [Validators.required],
      ],
      checkIn: [
        this.editing
          ? this.ngbDateParser.parse(
            moment(this.data.checkIn).toString()
          )
          : '',
        [Validators.required],
      ],
      checkOut: [
        this.editing
          ? this.ngbDateParser.parse(
            moment(this.data.checkOut).toString()
          )
          : '',
        [Validators.required],
      ],
      supplierInvoice: [
        {
        value: this.editing ? (this.data?.supplierInvoice ?? '') : (this.request?.supplierInvoice ?? ''),
        disabled: this.userType !== 'EMPLOYEE' 
        }
      ],
      bookType: [
        {
          value: this.editing ? (this.data?.bookType ?? '') : '',
          disabled: this.userType !== 'EMPLOYEE'
        }
      ],
      comments: [{ value: this.editing ? this.data.comments : "", disabled: this.userType != "EMPLOYEE" }],
      userUuid: this.userId,
      provider: [{ 
        value: this.editing ? (this.data?.provider || '') : '', 
        disabled: this.userType !== 'EMPLOYEE' 
      }],
      invoiced: [{
        value: this.editing ? (this.data?.invoiced || 'none') : 'none',
        disabled: this.userType !== 'EMPLOYEE'
      }],
    });

    if (this.editing) {
      this.form.addControl('price', new FormControl(
        {
          value: this.data.price.toFixed(2),
          disabled: this.data?.payment || this.data?.refund || this.userType != "EMPLOYEE"
        },
        [Validators.required, Validators.pattern(/^\d+([.,]\d{1,2})?$/)]
      ));
      this.form.addControl('wholesalePrice', new FormControl(
        {
          value: typeof this.data?.wholesalePrice === 'number'
            ? this.data.wholesalePrice.toFixed(2)
            : (this.data?.wholesalePrice || ''),
          disabled: this.data?.payment || this.data?.refund || this.userType != "EMPLOYEE"
        },
        [Validators.pattern(/^\d+([.,]\d{1,2})?$/)]
      ));

      if(!this.data.hotel) {
        this.form.addControl('roomType', new FormControl(
          {
            value: this.data.roomType || '',
            disabled: this.userType != "EMPLOYEE"
          }
        ));

        this.form.addControl('boardType', new FormControl(
          {
            value: this.data.boardType || '',
            disabled: this.userType != "EMPLOYEE"
          }
        ));
      }

      this.form.addControl('provider', new FormControl({
        value: this.data.provider || '',
        disabled: this.userType != "EMPLOYEE"
      }));

      this.form.addControl('marketingFee', new FormControl({
        value: typeof this.data?.marketingFee === 'number'
          ? this.data.marketingFee.toFixed(2)
          : (this.data?.marketingFee || ''),
        disabled: this.userType !== 'EMPLOYEE'
      }, [Validators.pattern(/^\d+([.,]\d{1,2})?$/)]));

      this.form.addControl('freeTaxes', new FormControl(
        {
          value: this.editing && this.data !== null && this.data.freeTaxes
            ? this.data.freeTaxes
            : false,
          disabled: this.userType !== "EMPLOYEE"
        },
        this.editing && this.data?.codePetition ? null : Validators.required
      ));
    }

    if (!this.data?.hotel && this.userType === "EMPLOYEE" && this.bookType !== 'airbnb') {
      const roomsValue = Number(this.request?.rooms) || 1;
      this.form.addControl('rooms', new FormControl(roomsValue, [Validators.required, Validators.min(1)]));
      this.form.addControl('travelersPerRoom', this.formBuilder.array([]));
      this.form.addControl('defaultTraveler', this.formBuilder.control([]));

      this.travelersPerRoom = this.form.get("travelersPerRoom") as FormArray;

      if(!this.editing){
        this.form.addControl('roomsInfo', this.formBuilder.array([]));
        this.initRoomsInfo(roomsValue);

        this.form.get("rooms")?.valueChanges.subscribe(value => {
          this.updateTravelersPerRoom(value);
          this.initRoomsInfo(value);
        });
      }else {
        this.getCompanyUsers(() => {
          const travelers = (this.data?.userUuid ?? []).map(uuid => {
            const user = this.companyUsers.find(u => u.uuid === uuid);
            return {
              uuid: user.uuid,
              name: user.name,
              lastname: user.lastname
            };
          });
          this.form.get("defaultTraveler")?.setValue(travelers);
          this.form.get("rooms")?.valueChanges.subscribe(value => {
            this.updateTravelersPerRoom(value);
          });
        });
      }

    }

    if (this.editing) {
      const initialIds = Array.isArray(this.data?.userUuid)
        ? this.data.userUuid
        : (this.data?.userUuid ? [this.data.userUuid] : []);

      this.maxSelection = initialIds.length || 1;

      this.form.addControl('traveler', new FormControl({
        value: initialIds,
        disabled: !(this.userType?.toLowerCase() === 'employee' || this.userType?.toLowerCase() === 'company')
      }));
    }

    if (this.data?.hotel) {
      this.form.addControl('address', new FormControl({ value: this.data ? this.data?.hotel?.address : '', disabled: this.userType != "EMPLOYEE" },
        [Validators.required]
      ));
    }
  
    if (this.form.value.checkIn) {
      this.form.patchValue({ checkIn: { day: this.form.value.checkIn.day, month: this.form.value.checkIn.month + 1, year: this.form.value.checkIn.year  } })
    }
    if (this.form.value.checkOut) {
      this.form.patchValue({ checkOut: { day: this.form.value.checkOut.day, month: this.form.value.checkOut.month + 1, year: this.form.value.checkOut.year } })
    }
    if (this.request) {
      this.request.initDate = moment(this.request.initDate).format(
        "DD/MM/YYYY"
      );
      const valueInit = {
        year: this.request.initDate.toString().split("/")[2] * 1,
        month: this.request.initDate.split("/")[1] * 1,
        day: this.request.initDate.split("/")[0] * 1,
      };
      this.form.patchValue({ checkIn: valueInit });
      this.request.endDate = moment(this.request.endDate).format("DD/MM/YYYY");
      const valueEnd = {
        year: this.request.endDate.toString().split("/")[2] * 1,
        month: this.request.endDate.split("/")[1] * 1,
        day: this.request.endDate.split("/")[0] * 1,
      };
      this.form.patchValue({ checkOut: valueEnd });
    }
  
    if(this.editing){
      this.getCompanyUsersAndUpdate();
    }

    if(!this.data?.hotel && !this.editing && this.userType === "EMPLOYEE"){
      this.getCompanyUsers();
    }

    this.loadHotelProviders();
  }

  // Buscador de ciudades
  getCities(value: string) {
    this.citiesList = [];
    if (value !== "" && value.length > 2) {
      cities.Table1.forEach((v) => {
        if (
          v["name"]?.toLowerCase().includes(value?.toLowerCase()) &&
          !this.citiesList.includes(v["name"])
        ) {
          this.citiesList.push(v["name"]);
        }
      });
    } else {
      this.citiesList = [];
    }
  }

  get f() {
    return this.form.controls;
  }

  getHotels(value: string) {
    if (value !== "" && this.city !== "") {
      hotels.hotels.forEach((h) => {
        {
          if (
            h["city"]?.toLowerCase().includes(this.city?.toLowerCase()) &&
            !this.hotelsList.includes(h.name)
          ) {
            this.hotelsList.push(h.name);
          }
        }
      });
    } else {
      this.hotelsList = [];
    }
  }

  cleanCitiesList(option) {
    this.city = option;
    this.citiesList = [];
  }

  cleanHotelsList() {
    this.hotelsList = [];
  }

  onSubmit() {
    if (!this.editing) {
      this.showPaymentCardSelector().then((selectedCard) => {
        if (!selectedCard && !this.company.bookedWithoutCard) {
          this.loading = false;
          return;
        }
  
        this.processBookingForm(selectedCard);
      });
    } else {
      this.processBookingForm();
    }
  }
  
  processBookingForm(selectedCard?: any) {
    this.isInvalid = false;
    this.loading = true;
    const travel = this.travelUtilsService.getTravelLocalStorage();
    const body = this.form.getRawValue();
    if (this.data?.hotel) {
      body.traveler = this.selectedTravelers.map(user => ({
        uuid: user.uuid,
        name: user.name,
        lastname: user.lastname
      }));
    }
    body["checkIn"] = moment(this.ngbDateParser.format(body["checkIn"]), "DD/MM/YYYY").format("YYYY-MM-DD");
    body["checkOut"] = moment(this.ngbDateParser.format(body["checkOut"]), "DD/MM/YYYY").format("YYYY-MM-DD");
    if (this.editing && body["price"]) {
      body["price"] = parseFloat(body["price"].toString().replace(",", ".")).toFixed(2);
    }
    if (this.editing) {
      if (
        body["wholesalePrice"] !== undefined &&
        body["wholesalePrice"] !== null &&
        body["wholesalePrice"] !== ''
      ) {
        body["wholesalePrice"] = parseFloat(
          body["wholesalePrice"].toString().replace(",", ".")
        ).toFixed(2);
      } else {
        delete body["wholesalePrice"];
      }
    }
    if (this.editing) {
      if (body["marketingFee"] !== undefined && body["marketingFee"] !== null && body["marketingFee"] !== '') {
        body["marketingFee"] = Number(
          body["marketingFee"].toString().replace(",", ".")
        );
      } else {
        delete body["marketingFee"];
      }
    }
    if (this.editing && this.data.codePetition) {
      delete body['freeTaxes'];
    }

    if (this.request || this.user) {
      body['holder'] = this.request ? this.request.holder : this.user ? { name: this.user.name, surname: this.user.lastname } : null;
    }

    if (this.userId) {
      body["userUuid"] = this.userId;
    }
    if (travel && travel.title) {
      body["travelName"] = travel.title;
    }
    if (selectedCard) {
      body["paymentCard"] = {
        name: selectedCard.name,
        token: selectedCard.token,
      };
    }
    body["file"] = this.files.length > 0 ? this.files : [];
    body.file = body.file.flat();
    body["filesToRemove"] = this.filesToRemove;
    if (!this.data?.hotel && this.userType === "EMPLOYEE" && this.bookType !== 'airbnb') {
      const allTravelersPerRoom = [
        this.form.get("defaultTraveler")?.value,
        ...this.getTravelersPerRoom?.value
      ];
  
      body["rooms"] = allTravelersPerRoom.length;
      body["travelersPerRoom"] = allTravelersPerRoom;
    }
    const roomsInfoControl = this.form.get('roomsInfo');
    if (roomsInfoControl && !this.editing) {
      body["roomsInfo"] = roomsInfoControl.value.map(room => {
        const { provider, marketingFee, wholesalePrice, ...rest } = room;
        const parsedWholesalePrice =
          wholesalePrice !== '' && wholesalePrice != null
            ? parseFloat(wholesalePrice.toString().replace(",", ".")).toFixed(2)
            : null;
        const parsedMarketingFee =
          marketingFee !== '' && marketingFee !== null && marketingFee !== undefined
            ? Number(marketingFee.toString().replace(",", "."))
            : null;

        return {
          ...rest,
          price: parseFloat(room.price.toString().replace(",", ".")).toFixed(2),
          providerUuid: provider || null,
          ...(parsedWholesalePrice !== null ? { wholesalePrice: parsedWholesalePrice } : {}),
          ...(parsedMarketingFee !== null && !Number.isNaN(parsedMarketingFee)
            ? { marketingFee: parsedMarketingFee }
            : {})
        };
      });
    }

    if(this.bookType === 'airbnb' || this.data?.hotel){
      delete body['travelersPerRoom'];
      delete body['defaultTraveler'];
    }
    if (!body.bookType) {
      delete body.bookType;
    }
    if (body.provider) {
      body.providerUuid = body.provider;
    }

    if (
      !this.data?.hotel &&
      this.bookType !== 'airbnb' &&
      (!body.travelersPerRoom || !Array.isArray(body.travelersPerRoom) || body.travelersPerRoom.length === 0)
    ) {
      const travelerIds: string[] = Array.isArray(body.traveler) ? body.traveler : (body.traveler ? [body.traveler] : []);

      const travelersObj = travelerIds
        .map(id => this.companyUsers.find(u => u.uuid === id))
        .filter(Boolean)
        .map(u => ({ uuid: u.uuid, name: u.name, lastname: u.lastname }));

      const room1 = travelersObj.length ? travelersObj : travelerIds.map(uuid => ({ uuid }));

      body.rooms = 1;
      body.travelersPerRoom = [room1];

      delete body.traveler;
    }

    this.sendInfo.emit(body);
  }

  onFileChange(event: any) {
    if (event.target.files.length > 0 && this.userType === 'EMPLOYEE') {
      for (let i = 0; i < event.target.files.length; i++) {
        this.files.push(event.target.files[i]);
      }
    }
  }

  onFileChangeCustom(event: any, roomIndex: number) {
    if (event.target.files.length > 0 && this.userType === 'EMPLOYEE') {
      const roomsArray = this.form.get('roomsInfo') as FormArray;
      const room = roomsArray.at(roomIndex);
      const currentFiles = room.get('files').value || [];
      room.get('files').setValue([...currentFiles, ...Array.from(event.target.files)]);
    }
  }

  removeFile(index: number) {
    const fileToRemove = this.existingFiles[index] || this.files[index];
    if (fileToRemove.url) {
      this.filesToRemove.push(fileToRemove.url);
      this.existingFiles.splice(index, 1);
    } else {
      this.files.splice(index, 1);
    }
  }

  removeFileCustom(roomIndex: number, fileIndex: number) {
    const roomsArray = this.form.get('roomsInfo') as FormArray;
    const room = roomsArray.at(roomIndex);
    const currentFiles = room.get('files').value || [];
    const updatedFiles = currentFiles.slice();
    updatedFiles.splice(fileIndex, 1);
    room.get('files').setValue(updatedFiles);
  }

  getOutMinDateManual() {
    return this.utilsService.getOutDate(
      this.minDateNgStruct,
      this.form.controls["checkIn"].value
    );
  }

  handleTravel(dataTravel: any) {
    this.bodyTravel = dataTravel;
    this.travelUtilsService.setTravelLocalStorage(this.bodyTravel);
    this.translate.get(["project.form.saved"]).subscribe((resp) => {
      this.ngxToastrService.typeSuccess(resp["project.form.saved"], "");
    });
  }

  closeModalCross() {
    this.modalService.dismissAll();
  }

  getCompanyUsersAndUpdate() {
    this.companyService.getCompanyUsers(this.companyUuid).subscribe(
      (res) => {
        this.companyUsers = res.map(user => ({
          name: user.name,
          lastname: user.lastname,
          uuid: user.uuid
        }));

        this.filteredUsers = [...this.companyUsers];

        const initialIds = Array.isArray(this.data?.userUuid)
          ? this.data.userUuid
          : (this.data?.userUuid ? [this.data.userUuid] : []);

        this.form.get('traveler')?.setValue(initialIds, { emitEvent: false });

        this.selectedTravelers = this.companyUsers.filter(u => initialIds.includes(u.uuid));

        this.syncSelectedTravelersWithControl();
      },
      (err) => console.error('Error fetching users:', err)
    );
  }

  getCompanyUsers(callback?: Function) {
    this.companyService.getCompanyUsers(this.companyUuid).subscribe(
      (res) => {
        this.companyUsers = res.map(user => ({
          name: user.name,
          lastname: user.lastname,
          uuid: user.uuid
        }));
        this.filteredUsers = [...this.companyUsers];  
        if (this.form?.get('traveler')) {
          this.syncSelectedTravelersWithControl();
        }
        if (callback) {
          callback();
        }
      },
      (err) => {}
    );
  }

  updateTravelersPerRoom(roomCount: number) {
    const travelersArray = this.getTravelersPerRoom;
    const currentValues = travelersArray.value;
  
    while (travelersArray.length < roomCount - 1) {
      travelersArray.push(this.formBuilder.control([]));
    }
    while (travelersArray.length > roomCount - 1) {
      travelersArray.removeAt(travelersArray.length - 1);
    }
    travelersArray.controls.forEach((control, index) => {
      if (currentValues[index]) {
        control.setValue(currentValues[index]);
      }
    });
  }
  
  compareUsers(user1: any, user2: any): boolean {
    return user1 && user2 ? user1.uuid === user2.uuid : user1 === user2;
  }
  
  get getTravelersPerRoom(): FormArray {
    return this.form.get('travelersPerRoom') as FormArray;
  }

  get getDefaultTraveler(): FormArray {
    return this.form.get('defaultTraveler') as FormArray;
  }
  
  isFormValid(): boolean {
    if(this.data?.hotel || this.userType !== "EMPLOYEE" || this.bookType === 'airbnb'){
      return true;
    }
    const travelersPerRoom = this.getTravelersPerRoom.value;
    const allRoomsHaveTravelers = travelersPerRoom.every(room => room && room.length > 0);
  
    return this.form.valid && allRoomsHaveTravelers;
  }

  showPaymentCardSelector(): Promise<any> {
    if (this.company.bookedWithoutCard) {
      return Promise.resolve(null);
    }

    if (!Array.isArray(this.user.paymentCards)) {
      this.user.paymentCards = this.user.paymentCards ? [this.user.paymentCards] : [];
    }

    /* if (!Array.isArray(this.user.personalPaymentCards)) {
      this.user.personalPaymentCards = this.user.personalPaymentCards ? [this.user.personalPaymentCards] : [];
    } */
    this.user.paymentCards = this.user.paymentCards.filter(c => c?.token);

    if ((!this.user.paymentCards || this.user.paymentCards.length === 0) /* && (!this.user.personalPaymentCards || this.user.personalPaymentCards.length === 0) */) {
      this.translate
        .get(["common.no-card-user-error"])
        .pipe(take(1))
        .subscribe((value) =>
          this.ngxToastrService.typeInfo(
            null,
            value["common.no-card-user-error"]
          )
        );
      return Promise.resolve(null);
    }

    const defaultToken = this.company?.cardRedsys?.find(c => c?.isDefault && c?.token)?.token || null;

    if (defaultToken) {
      this.user.paymentCards = [
        ...this.user.paymentCards.filter(c => c.token === defaultToken),
        ...this.user.paymentCards.filter(c => c.token !== defaultToken),
      ];
    }

    return new Promise((resolve) => {
      const modalRef = this.modalService.open(UserCardModalComponent, {
        windowClass: 'custom-modal-user-card',
        centered: true,
        backdrop: 'static',
        keyboard: false
      });
      modalRef.componentInstance.company = this.company;
      modalRef.componentInstance.bookCards = this.user.paymentCards;
      /* modalRef.componentInstance.bookPersonalCards = this.user.personalPaymentCards; */
      modalRef.componentInstance.fromBookSelect = true;
      modalRef.componentInstance.cardSelected.subscribe((selectedCard) => {
        resolve(selectedCard);
      });
      modalRef.result.catch(() => {
        resolve(null);
      });
    });
  }

  trackByUuid(_: number, user: { uuid: string }) { return user.uuid; }

  get selectedTravelersNames(): string {
    return this.selectedTravelers.map(user => `${user.name} ${user.lastname}`).join(", ");
  }

  applyFilter(filterValue: string) {
    const v = (filterValue || '').trim().toLowerCase();
    this.filteredUsers = !v
      ? [...this.companyUsers]
      : this.companyUsers.filter(u =>
          `${u.name} ${u.lastname}`.toLowerCase().includes(v)
        );
  }

  initRoomsInfo(count: number) {
    const roomsInfoArray = this.form.get('roomsInfo') as FormArray;
    roomsInfoArray.clear();
    for (let i = 0; i < count; i++) {
      roomsInfoArray.push(this.formBuilder.group({
        price: ['', [Validators.required, Validators.pattern(/^\d+([.,]\d{1,2})?$/)]],
        wholesalePrice: ['', [Validators.pattern(/^\d+([.,]\d{1,2})?$/)]],
        files: [[]],
        roomType: [''],
        boardType: [''],
        freeTaxes: [false],
        provider: [''],
        marketingFee: ['', [Validators.pattern(/^\d+([.,]\d{1,2})?$/)]]
      }));
    }
  }

private loadHotelProviders(): void {
  this.loadingHotelProviders = true;

  this.providersService.getProviders('hotel' as ProviderType).subscribe({
    next: (items) => {
      const providers = (items || []).filter(p => !!p?.uuid && !!p?.name);

      const currentRaw =
        (this.data?.provider ||
         this.form?.get('provider')?.value ||
         ''
        ).toString().trim();

      let selectedUuid: string | null = null;

      if (currentRaw) {
        const byUuid = providers.find(p => p.uuid === currentRaw);
        if (byUuid) {
          selectedUuid = byUuid.uuid;
        } else {
          const byName = providers.find(
            p => (p.name || '').toLowerCase() === currentRaw.toLowerCase()
          );
          if (byName) {
            selectedUuid = byName.uuid;
          }
        }
      }

      this.hotelProviderOptions = providers;
      if (selectedUuid && this.form?.get('provider')) {
        this.form.get('provider')!.setValue(selectedUuid);
      }
      this.loadingHotelProviders = false;
    },
    error: () => {
      this.hotelProviderOptions = [];
      this.loadingHotelProviders = false;
    }
  });
}

  private syncSelectedTravelersWithControl() {
    if (this.travelerSyncInitialized) return;
    this.travelerSyncInitialized = true;

    const ctrl = this.form.get('traveler') as FormControl;
    if (!ctrl) return;

    ctrl.valueChanges.subscribe((uuids: any) => {
      const ids = Array.isArray(uuids) ? uuids : (uuids ? [uuids] : []);
      this.selectedTravelers = this.companyUsers.filter(u => ids.includes(u.uuid));

      this.syncDefaultTravelerFromSelected();
    });

    const current = ctrl.value;
    const ids = Array.isArray(current) ? current : (current ? [current] : []);
    this.selectedTravelers = this.companyUsers.filter(u => ids.includes(u.uuid));

    this.syncDefaultTravelerFromSelected();
  }

  onTravelerOptionToggle(uuid: string, ev: MatOptionSelectionChange) {
    if (!ev.isUserInput) return;

    const ctrl = this.form.get('traveler') as FormControl;
    const current: string[] = Array.isArray(ctrl.value)
      ? ctrl.value
      : (ctrl.value ? [ctrl.value] : []);

    if (!ev.source.selected) {
      const next = current.filter(id => id !== uuid);
      ctrl.setValue(next, { emitEvent: true });
      return;
    }

    const without = current.filter(id => id !== uuid);
    let next = [...without, uuid];

    if (next.length > this.maxSelection) {
      next = next.slice(next.length - this.maxSelection);
    }

    ctrl.setValue(next, { emitEvent: true });
  }

  onTravelerOpenedChange(opened: boolean) {
    if (!opened) {
      this.filteredUsers = [...this.companyUsers];
    }
  }

  private syncDefaultTravelerFromSelected() {
    const ctrl = this.form.get('defaultTraveler');
    if (!ctrl) return;

    const updated = this.selectedTravelers.map(u => ({
      uuid: u.uuid,
      name: u.name,
      lastname: u.lastname
    }));

    ctrl.setValue(updated, { emitEvent: false });
  }

  onSelectToggle(opened: boolean) {
  if (!opened) {
      this.filteredUsers = [... this.companyUsers];
    }
  }
}
